import * as yup from 'yup'
import { defineMessages } from 'react-intl'
import { isEmpty } from 'lodash'

import { DISCOUNT_TYPE } from 'features/Coupons/components/DiscountType/constants'

const messages = defineMessages({
  required: {
    id: 'dictionary.required',
    defaultMessage: 'Required'
  },
  minValue: {
    id: 'dictionary.minValue',
    defaultMessage: 'The minimum value is 1'
  }
})

const companyMessages = defineMessages({
  required: {
    id: 'coupons.form.company.required',
    defaultMessage: 'The company is required'
  }
})

const campaignMessages = defineMessages({
  required: {
    id: 'coupons.form.campaign.required',
    defaultMessage: 'The campaign is required'
  }
})

const codeMessages = defineMessages({
  required: {
    id: 'coupons.form.code.required',
    defaultMessage: 'The code is required'
  },
  max: {
    id: 'coupons.form.code.max',
    defaultMessage: 'The code can be up to 10 characters'
  }
})

const startsAtMessages = defineMessages({
  required: {
    id: 'coupons.form.startsAt.required',
    defaultMessage: 'The starting date is required'
  }
})

const endsAtMessages = defineMessages({
  required: {
    id: 'coupons.form.endsAt.required',
    defaultMessage: 'The ending date is required'
  }
})

const channelsMessages = defineMessages({
  required: {
    id: 'coupons.form.channels.required',
    defaultMessage: 'You need to select at least one channel'
  }
})

const salesChannelsMessages = defineMessages({
  required: {
    id: 'coupons.form.salesChannels.required',
    defaultMessage: 'You need to select at least one sales channel'
  }
})

const valueMessages = defineMessages({
  required: {
    id: 'coupons.form.value.required',
    defaultMessage: 'The value is required'
  },
  max: {
    id: 'coupons.form.value.max',
    defaultMessage: 'The value can not exceed 100%'
  }
})

const limitMessages = defineMessages({
  required: {
    id: 'coupons.form.limit.required',
    defaultMessage: 'The limit is required'
  }
})

const confirmationModalitiesMessages = defineMessages({
  required: {
    id: 'coupons.form.confirmationModalities.required',
    defaultMessage: 'You need to select at least one modality'
  }
})

export const schema = (intl: TSFixMe): TSFixMe => {
  return yup.object().shape({
    company: yup.object().shape({
      id: yup.string().required(intl.formatMessage(companyMessages.required))
    }),
    campaign: yup.object().shape({
      id: yup.string().required(intl.formatMessage(campaignMessages.required))
    }),
    code: yup
      .string()
      .required(intl.formatMessage(codeMessages.required))
      .max(10, intl.formatMessage(codeMessages.max)),
    startsAt: yup.string().required(intl.formatMessage(startsAtMessages.required)),
    endsAt: yup.string().required(intl.formatMessage(endsAtMessages.required)),
    channels: yup.array().required(intl.formatMessage(channelsMessages.required)),
    discountType: yup.string(),
    value: yup
      .number()
      .required(intl.formatMessage(valueMessages.required))
      .when('discountType', {
        is: DISCOUNT_TYPE.PERCENTAGE,
        then: yup.number().max(100, intl.formatMessage(valueMessages.max))
      }),
    cityDestinations: yup
      .array()
      .test('is-city-destinations-required', intl.formatMessage(messages.required), function (value) {
        if (this.parent.allCitiesAndSegments) {
          return true
        }
        return !isEmpty(value)
      }),
    cityOrigins: yup.array().test('is-city-origins-required', intl.formatMessage(messages.required), function (value) {
      if (this.parent.allCitiesAndSegments) {
        return true
      }
      return !isEmpty(value)
    }),
    segments: yup.array().test('is-segments-required', intl.formatMessage(messages.required), function (value) {
      if (this.parent.allCitiesAndSegments || this.parent.allSegments) {
        return true
      }
      return !isEmpty(value)
    }),
    constraints: yup.object().shape({
      minTicketsCount: yup
        .number()
        .min(1, intl.formatMessage(messages.minValue))
        .required(intl.formatMessage(messages.required)),
      bookingTypes: yup.array().min(1, intl.formatMessage(messages.required)),
      minSale: yup.string(),
      limit: yup.string().required(intl.formatMessage(limitMessages.required)),
      salesChannels: yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().required(),
            name: yup.string().required()
          })
        )
        .min(1, intl.formatMessage(salesChannelsMessages.required)),
      departureDateRanges: yup.array().of(
        yup.object().shape({
          from: yup.string().required(intl.formatMessage(messages.required)),
          to: yup.string().required(intl.formatMessage(messages.required))
        })
      ),
      confirmationModalities: yup
        .array()
        .min(1, intl.formatMessage(confirmationModalitiesMessages.required))
        .required(intl.formatMessage(confirmationModalitiesMessages.required))
    })
  })
}
